module.exports = __webpack_public_path__ + "img/anlunbg01.ca8fcd44.jpg";